document.addEventListener("DOMContentLoaded", function(){
    // Variables - Elements
    var cookieTheme = document.querySelector(".cookie-consent-theme");
    var cookieOverlay = document.querySelector(".cookie-overlay");
    var cookieBoxContainer = document.querySelector(".cookie-consent-container");
    var cookieBox = document.querySelector(".cookie-consent-tool");
    var cookieBoxSettings = typeof cookieBox != "undefined" ? cookieBox.dataset : false;
    var cookieSettingsSimple = document.querySelector(".cookie-settings--simple");
    var cookieSettingsComplex = document.querySelector(".cookie-settings--complex");
    var cookieButtonOpen = document.querySelectorAll(".cookie-open");
    var cookieButtonClose = document.querySelectorAll(".cookie-close");
    var cookieModeToggler = document.querySelectorAll(".cookie-mode-toggler");
    var cookieFooterSettingsButton = document.querySelector(".cookie-footer-settings-button") ? true : false;
    var cookieSubmitEssentials = document.querySelector("input[type='submit'][name$='[submit_essentials]']");
    var cookieSubmitIndividual = cookieSettingsComplex.querySelector("input[type='submit'][name$='[submit_individual]']");
    var cookieJson = getCookie("hh_ext_cookie_consent") ? JSON.parse(decodeURIComponent(getCookie("hh_ext_cookie_consent"))) : false;
    var acc = document.getElementsByClassName("cookie-group-tab");

    var langCountryCode = typeof document.querySelector("html").lang != "undefined" ? document.querySelector("html").lang : false;
    var langDict = {
        "de": {
            "privacy": "Datenschutz",
            "cookie_settings_edit": "Cookie Einstellungen ändern",
            "media_placeholder_desc": "Um dieses Medium betrachten zu können klicken Sie bitte auf den nachfolgenden Button um die Cookie & Datenschutzrichtlinien zu akzeptieren: ",
            "media_placeholder_btn": "Medium ansehen und Datenschutzerklärung dieses Anbieters akzeptieren"
        },
        "en": {
            "privacy": "Privacy",
            "cookie_settings_edit": "Edit Cookie Settings",
            "media_placeholder_desc": "To view this medium please click on the button below to accept the cookie & privacy policy: ",
            "media_placeholder_btn": "Show media element and accept cookie & privacy policy"
        },
        "it": {
            "privacy": "Protezione dei dati",
            "cookie_settings_edit": "Modificare le impostazioni dei Cookies",
            "media_placeholder_desc": "Per visualizzare questo media, cliccare sul seguente pulsante per accettare l'Informativa sulla privacy e Cookies: ",
            "media_placeholder_btn": "Visualizza l'elemento mediatico e accetta Cookies e l'informativa sulla privacy"
        },
        "fr": {
            "privacy": "Protection des données",
            "cookie_settings_edit": "Modifier les paramètres des Cookies",
            "media_placeholder_desc": "Pour afficher ce média, veuillez cliquer sur le bouton suivant pour accepter les Cookies et la politique de confidentialité: ",
            "media_placeholder_btn": "Afficher l'élément média et accepter les Cookies et la politique de confidentialité"
        },
        "es": {
            "privacy": "Protección de datos",
            "cookie_settings_edit": "Editar la configuración de las Cookies",
            "media_placeholder_desc": "Para ver este medio, por favor haga clic en el botón de abajo para aceptar Cookies y la política de privacidad: ",
            "media_placeholder_btn": "Ver el elemento multimedia y aceptar Cookies y la política de privacidad"
        },
        "pt": {
            "privacy": "Proteção de dados",
            "cookie_settings_edit": "Editar configurações de Cookies",
            "media_placeholder_desc": "Para visualizar esta mídia, clique no botão abaixo para aceitar Cookies & política de privacidade: ",
            "media_placeholder_btn": "Mostrar elemento de mídia e aceitar Cookies e política de privacidade"
        }
    };

    var lang = langCountryCode ? langDict[langCountryCode.substring(0, 2)] : false; // Usage Example: lang["privacy"]

    // Multimedia Enabler - A placeholder will be shown if a media service wasn't enabled by the user
    // (the user can enable/accept media services/cookies (e.g. YouTube, GoogleMaps) on the website directly through a additional button)
    var media = {
        "maps": {
            "googleMaps": document.querySelectorAll("iframe[src^='https://www.google.com/maps'], .gmaps, #gmaps, .googlemaps, #googlemaps, #googleMap, #map_wrapper"),
            "openstreetmap": document.querySelectorAll("iframe[src^='https://www.openstreetmap.org/'], .leaflet-container:not(.openstreetmap), .openstreetmap, .osm-wrapper")
        },
        "video": {
            "youtube": document.querySelectorAll("iframe[src^='https://www.youtube-nocookie.com/'], iframe[src^='https://www.youtube.com/']"),
            "vimeo": document.querySelectorAll("iframe[src^='https://player.vimeo.com/']")
        },
        "custom": {

        }
    };

    // Helper Functions
    var isDebug = document.querySelector(".cookie-consent-theme") && document.querySelector(".cookie-consent-theme").dataset.debug == "1" ? true : false;

    function debugMsg(title, data){
        if(isDebug){
            console.log(title, data);
        }
    }

    // Reuse/Add media logic to custom media elements (IFrame, etc.)
    document.querySelectorAll("input[type='checkbox'][name*='[custom]']").forEach(function(el){
        if(el.dataset.cspUid && el.dataset.cspDefaultSrc){
            // el.dataset.placeholderImage
            media["custom"][el.dataset.cspUid] = document.querySelectorAll("iframe[src^='https://"+el.dataset.cspDefaultSrc+"/'], audio[src^='https://"+el.dataset.cspDefaultSrc+"/'], embed[src^='https://"+el.dataset.cspDefaultSrc+"/'], img[src^='https://"+el.dataset.cspDefaultSrc+"/'], video[src^='https://"+el.dataset.cspDefaultSrc+"/'], form[action^='https://"+el.dataset.cspDefaultSrc+"/']");
        } else {
            debugMsg("cookie consent [INFO]: cspDefaultSrc and/or cspUid is not set for the following element: ", el);
        }
    });

    debugMsg("cookie consent [INFO]: cookieJson ", cookieJson);
    debugMsg("cookie consent [INFO]: media ", media);

    // Show Cookie Box if no cookie is set
    if(!getCookie("hh_ext_cookie_consent")){
        cookieBoxContainer.classList.remove("cc-hide");
    } else {
        cookieBoxContainer.classList.add("cc-hide");
    }

    // Preselection of Input Fields
    for(var mediaCategoryKey in media){
        for(var mediaKey in media[mediaCategoryKey]){
            if(media[mediaCategoryKey][mediaKey]){
                media[mediaCategoryKey][mediaKey].forEach(function(el){
                    var cookiePreselect = document.querySelector("input[type='checkbox'][name$='["+mediaKey+"]']");

                    debugMsg("cookie consent [INFO]: cookiePreselect: ", cookiePreselect);

                    // Create Custom/Media Placeholder for easier User Activation
                    // (but only if the cookie JSON doesn't align with the media element given)
                    // (e.g. if youtube hasn't been activated by the user)
                    // if(cookiePreselect && !cookiePreselect.checked){
                    //
                    // TODO: The CookieHook still uses 2 formats, e.g. { "custom-5": "1" } and { "custom": { "5": "1" } }
                    // one of those needs to be removed / merged
                    // (the generation of those formats depend on "Accept all cookies" and "individual" cookies)
                    if(!cookieJson["custom-"+mediaKey] && !cookieJson[mediaKey] && (!cookieJson["custom"] || !cookieJson["custom"][mediaKey])){
                        var placeholder = el.tagName == "IFRAME" ? el.parentNode : el;
                        var placeholderBox = document.createElement("div");
                        var placeholderBtnAccept = document.createElement("a");
                        var placeholderTextHead = document.querySelector(".cookie-group-title-" + (cookiePreselect.dataset.cspCookieId ? cookiePreselect.dataset.cspCookieId : mediaKey));
                        var placeholderTextBody = document.querySelector(".cookie-group-content-" + (cookiePreselect.dataset.cspCookieId ? cookiePreselect.dataset.cspCookieId : mediaKey));

                        placeholder.classList.add("cc-placeholder");
                        placeholder.classList.add("cc-placeholder-" + mediaCategoryKey);
                        placeholder.classList.add("cc-placeholder-" + mediaKey);

                        if(typeof cookieTheme.getAttribute("data-primary-color") != "undefined"){
                            placeholder.setAttribute("style", "--primaryColor:" + cookieTheme.getAttribute("data-primary-color"));
                            debugMsg("cookie consent [INFO]: Cookie Theme Color is set to ", cookieTheme.getAttribute("data-primary-color"));
                        }

                        if(cookiePreselect.dataset.placeholderImage){
                            placeholder.style.backgroundImage = "url("+cookiePreselect.dataset.placeholderImage+")";
                        }

                        // if(placeholderTextHead && placeholderTextBody){
                        //     placeholderBox.innerHTML = (placeholderTextHead ? placeholderTextHead.outerHTML : "") + (placeholderTextBody ? placeholderTextBody.outerHTML : "");
                        // } else {
                        //     debugMsg("cookie consent [INFO]: No placeholderTextHead and/or placeholderTextBody defined for media key: ", mediaKey);
                        //     placeholderBox.innerHTML = "";
                        // }

                        if(placeholderTextHead){
                            placeholderBox.innerHTML = (placeholderTextHead ? placeholderTextHead.outerHTML : "");
                        } else {
                            debugMsg("cookie consent [WARNING]: No placeholderTextHead and/or placeholderTextBody defined for media key: ", mediaKey);
                            placeholderBox.innerHTML = "";
                        }

                        // placeholderBox.innerHTML += "<p class='cc-placeholder-desc'>"+ lang["media_placeholder_desc"] +"</p>";
                        placeholderBox.classList.add("cc-placeholder-box");
                        placeholderBtnAccept.innerText = lang["media_placeholder_btn"];
                        placeholderBtnAccept.classList.add("cc-placeholder-btn-accept");

                        placeholderBox.appendChild(placeholderBtnAccept);
                        placeholder.appendChild(placeholderBox);

                        placeholderBtnAccept.addEventListener("click", function(e){
                            e.preventDefault();

                            if(cookiePreselect){
                                cookiePreselect.checked = true;
                                cookiePreselect.value = 1;

                                cookieBoxContainer.classList.remove("cc-hide");
                                cookieSettingsSimple.classList.remove("cc-active");
                                cookieSettingsComplex.classList.add("cc-active");

                                // debugMsg(cookiePreselect.closest(".cookie-group").querySelector(".cookie-group-tab:not(.cc-active)"));

                                if (Element.prototype.closest){
                                    if(cookiePreselect.closest(".cookie-group")){
                                        cookiePreselect.closest(".cookie-group").querySelector(".cookie-group-tab:not(.cc-active)").click();
                                    } else {
                                        debugMsg("cookie consent [WARNING]: No cookie group (accordion) found for ", cookiePreselect);
                                    }
                                }

                                // cookieSettingsComplex.querySelector("form").submit();
                                // cookieSubmitIndividual.click();
                            } else {
                                debugMsg("cookie consent [WARNING]: This cookie input field does not exist: ", mediaKey);
                            }
                        });
                    }
                    //}
                });
            }
        }
    }

    // Preselect Fields/Checkboxes of the cookie form depending on the csp cookie values
    if(cookieJson && typeof cookieJson["essentials"] == "undefined"){
        for(cookieKey in cookieJson){
            if(cookieKey.match(/^[a-zA-Z0-9-_]+$/i)){
                var inputPreselect = document.querySelector("input[type='checkbox'][name$='["+ cookieKey +"]']");

                if(cookieKey == "custom"){
                    for(cookieKeyCustom in cookieJson[cookieKey]){
                        var inputPreselect = document.querySelector("input[type='checkbox'][name$='[custom]["+ cookieKeyCustom.replace("custom", "") +"]']");

                        if(inputPreselect){
                            inputPreselect.checked = true;
                            inputPreselect.value = 1;
                        } else {
                            debugMsg("cookie consent [ERROR]: This cookie input field does not exist: ", cookieKeyCustom);
                        }
                    }
                } else if(inputPreselect){
                    inputPreselect.checked = true;
                    inputPreselect.value = 1;
                } else {
                    debugMsg("cookie consent [ERROR]: This cookie input field does not exist: ", cookieKey);
                }
            } else {
                debugMsg("cookie consent [ERROR]: This cookieKey name has prohibited characters: ", cookieKey);
            }
        }
    }

    debugMsg("cookie consent [INFO]: JSON ", cookieJson);

    // Individual Cookie Button & Page / Pagination
    cookieModeToggler.forEach(function(el){
        el.addEventListener("click", function(e){
            e.preventDefault();

            if(cookieSettingsComplex.classList.contains("cc-active")){
                cookieSettingsSimple.classList.add("cc-active");
                cookieSettingsComplex.classList.remove("cc-active");
            } else {
                cookieSettingsSimple.classList.remove("cc-active");
                cookieSettingsComplex.classList.add("cc-active");
            }
        });
    });

    // Cookie Footer Settings Button (creates automatically a footer link for the user to reopen the cookie box)
    if(cookieBoxSettings.footerSettingsButton == "1"){
        var footerPrivacyProtectionLink = document.querySelectorAll(".footer li, #footer li");
        var privacyText = lang["privacy"] ? lang["privacy"] : false;

        if(footerPrivacyProtectionLink.length){
            footerPrivacyProtectionLink.forEach(function(el){
                var elLink = el.querySelector("a") ? el.querySelector("a") : false;
                var elInnerHTML = elLink ? elLink.innerHTML.toLowerCase() : false;

                if(elLink && lang && privacyText && elInnerHTML.search(privacyText.toLowerCase()) != -1){
                    var cookieButtonFooterEdit = document.createElement("li");

                    cookieButtonFooterEdit.classList.add("cookie-open-wrapper");
                    cookieButtonFooterEdit.innerHTML = "<a class='cookie-open' href='#'>"+lang["cookie_settings_edit"]+"</a>";
                    cookieButtonFooterEdit.addEventListener("click", function(e){
                        e.preventDefault();
                        cookieBoxContainer.classList.remove("cc-hide");
                    });

                    el.insertAdjacentElement("afterend", cookieButtonFooterEdit);
                }
            });
        }
    }

    // Create link(s) functionality for reopening the Cookie Box/Settings
    cookieButtonOpen.forEach(function(el){
        el.addEventListener("click", function(e){
            e.preventDefault();
            cookieBoxContainer.classList.remove("cc-hide");
        });
    });

    // Close Button (optional)
    cookieButtonClose.forEach(function(el){
        el.addEventListener("click", function(e){
            e.preventDefault();
            setCookieDefault();
        });
    });

    // Overlay Close Logic
    cookieOverlay.addEventListener("click", function(e){
        e.preventDefault();
        setCookieDefault();
    });

    // Accordion Menu
    for (var i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function(e) {
            e.preventDefault();

            var tab = this;
            var panel = tab.nextElementSibling;

            // Toggle Active Class
            if(tab.classList.contains("cc-active")){
                tab.classList.remove("cc-active");
                panel.classList.remove("cc-active");
            } else {
                tab.classList.add("cc-active");
                panel.classList.add("cc-active");
            }

            // Display Panel / Accordion Content (sets / resets max-height for css transition)
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
      });
    }

    // Helper Functions
    function getCookie(name) {
	    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	    return v ? v[2] : null;
	}

    function setCookie(cname, cvalue, exdays) {
    	var d = new Date();
        var expiryDays = typeof exdays != "undefined" ? exdays : 30;
    	d.setTime(d.getTime() + (expiryDays*24*60*60*1000));
    	var expires = "expires="+ d.toUTCString();
    	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function setCookieDefault(){
        if(!getCookie("hh_ext_cookie_consent")){
            setCookie("hh_ext_cookie_consent", '{"essentials":"1"}');
        }

        cookieBoxContainer.classList.add("cc-hide");
    }
});
